<Modal
  title="Confirm donation is complete"
  actionTitle="Confirm"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <p class="block">Please confirm that the donation has been collected or delivered.</p>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let id : RequestId;

  import { logging } from '../../../../../../lib/logging';
  import { uiState } from "../../../../../../lib/uiState";
  import Modal from "../../../../../_components/Modal.svelte";

  let errorMessage : string;
  let isLoading = false;

  async function apply() {
    isLoading = true;

    let firebase = window.firebase;

    await firebase
      .functions()
      .httpsCallable('api-request-completematch')({ id } as CompleteMatchParams)
      .then(() => {
        $uiState.activeModal = undefined;
      })
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));
  }
</script>
